import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getValidKeys, getHasAnsweredAllQuestions } from "../../../../../store/Selectors";
import { useAppContext } from "../../../Providers";
import { Routes as RoutePaths } from "../../Constants";
import { getFirstUnansweredQuestionRoute } from "../../getFirstUnansweredQuestionRoute";
function PrerequisiteRedirect(_ref) {
  var children = _ref.children,
    hasAnsweredAllQuestions = _ref.hasAnsweredAllQuestions,
    validKeys = _ref.validKeys;
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  if (hasAnsweredAllQuestions) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  var hasPartialApplication = validKeys.length > 0;
  if (hasPartialApplication) {
    var isAnonymousUser = !userId;
    if (isAnonymousUser) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: RoutePaths.RestartProgress
      });
    }
    var firstUnansweredQuestionRoute = getFirstUnansweredQuestionRoute(validKeys);
    return /*#__PURE__*/React.createElement(Redirect, {
      to: firstUnansweredQuestionRoute
    });
  }
  return /*#__PURE__*/React.createElement(Redirect, {
    to: RoutePaths.Eligibility.CheckEligibilityIntro
  });
}
var mapStateToProps = function mapStateToProps(state) {
  return {
    hasAnsweredAllQuestions: getHasAnsweredAllQuestions(state),
    validKeys: getValidKeys(state)
  };
};
export default connect(mapStateToProps)(PrerequisiteRedirect);